export default function Heading({title, mb}){

    return(
        <h1 className="text-[20px] font-medium font-ibm-plex-sans text-black" style={{marginBottom: mb}}>
            {title}
        </h1>
    )
}